/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import {
    object, string, bool, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { ducks as checkoutDucks } from '../../../../state/ducks/Checkout';
import { getCurrentUser } from '../../../../state/ducks/App/App-Selectors';
import { actions as tagManagerActions } from '../../../../state/ducks/TagManager/ducks/TagManager';
import { useAuth } from '../../../../state/ducks/Member/ducks/Auth/Plugin/Auth';

const {
    common: { commonSelectors },
} = checkoutDucks;

const styles = (theme) => ({
    metaHeaderRoot: {
        display: 'grid',
        marginTop: '40px',
        gridTemplateColumns: 'repeat(3, 33%)',
        [theme.breakpoints.down('md')]: {
            marginTop: '10px',
            padding: '0 15px',
            display: 'inline-block',
        },
        '& a': {
            color: '#6c6c6c',
            '&:last-child': {
                color: theme.palette.common.black,
                fontWeight: 600,
            },
        },
        '& .customer-detail': {
            textAlign: 'center',
            [theme.breakpoints.down('md')]: {
                textAlign: 'left',
                padding: '15px 0',
                marginTop: '20px',
                borderTop: '1px solid',
                borderBottom: '1px solid',
            },
            '& .MuiGrid-root': {
                '& a': {
                    fontWeight: 400,
                },
            },
        },
        '& .no-decoration': {
            textDecoration: 'none',
        },
        '& .shopping-cart': {
            fontWeight: 'bold',
            fontSize: '0.625rem',
            textTransform: 'uppercase',
            [theme.breakpoints.down('md')]: {
                width: '100%',
                display: 'inline-block',
            },
        },
        '&.logged-in': {
            [theme.breakpoints.down('md')]: {
                padding: '0 15px',
                marginTop: '10px',
                alignItems: 'center',
                display: 'grid !important',
                gridTemplateColumns: '50% 0 50%',
            },
            '& .customer-detail': {
                border: '0',
                padding: '0',
                marginTop: '0',
                textAlign: 'right',
                '& span': {
                    fontSize: '14px',
                    '& a': {
                        marginLeft: '5px',
                    },
                },
            },
        },
    },
    icons: {
        width: '100%',
        textAlign: 'right',
        '& hr': {
            marginTop: '1rem',
            marginBottom: '1rem',
            border: '0',
            borderTop: '1px solid rgba(0,0,0,.1)',
            '& +img': {
                paddingRight: '0.5rem',
            },
        },
        '& img': {
            verticalAlign: 'middle',
        },
    },
    loginLink: {
        color: '#000',
        fontWeight: '600',
        textDecoration: 'none',
        cursor: 'pointer',
    },
});

const CheckoutMetaHeaderPLA = ({
    classes,
    orderId,
    currentUser,
    profileInfo,
    icons,
    loginText,
    trackEvent,
}) => {
    const isLoggedIn = currentUser.accessToken && profileInfo.firstName;
    const name = profileInfo.firstName.charAt(0).toUpperCase() + profileInfo.firstName.slice(1);
    const { loginByRedirect } = useAuth();
    return (
        <>
            <Grid container justifyContent="space-between" className={`${classes.metaHeaderRoot} ${isLoggedIn ? 'logged-in' : ''}`}>
                <Link to={`/checkout/cart/${orderId}`} className="shopping-cart">
                    Back to Shopping Cart
                </Link>
                <div />
                <div className="customer-detail">
                    {
                        isLoggedIn
                            ? (
                                <Grid>
                                    <b>Hello, {name}!</b>
                                    <span> Not you?
                                        <Link to="/auth/logout">Logout</Link>
                                    </span>
                                </Grid>
                            )
                            : (
                                <div
                                    role="button"
                                    tabIndex={-1}
                                    onKeyDown={() => {}}
                                    onClick={async () => {
                                        trackEvent({
                                            eventName: 'feature_interaction', eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Normal|<<pageType>>',
                                        });
                                        loginByRedirect();
                                    }}
                                    className={`${classes.loginLink} no-decoration`}
                                >{loginText}
                                </div>
                            )
                    }
                </div>
            </Grid>

            {
                icons
                    ? (
                        <div className={classes.icons}>
                            <hr />
                            <img src="https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt860e1da22e2299d5/643571f94ff9d11208652938/norton-a00e4e56d05fd656081241618eedee12[1].png" alt="norton" />
                        </div>
                    ) : ''
            }
        </>
    );
};

CheckoutMetaHeaderPLA.propTypes = {
    classes: object.isRequired,
    orderId: string.isRequired,
    currentUser: object.isRequired,
    profileInfo: object.isRequired,
    icons: bool,
    loginText: string,
    trackEvent: func.isRequired,
};

CheckoutMetaHeaderPLA.defaultProps = {
    icons: true,
    loginText: 'Sign in or Create Account for Faster & Easier Checkout',
};

const mapStateToProps = (state) => ({
    orderId: commonSelectors.getOrderId(state),
    currentUser: getCurrentUser(state),
    profileInfo: state.member.profile,
});
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CheckoutMetaHeaderPLA));
